import { EntityService } from '../../../service/EntityService';
import {
  MqrConsentResponse,
  normalizeMqrConsentResponse,
  normalizePaymentBankConfigs,
  PaymentBankConfig,
} from './constants';

export class BankService extends EntityService {

  static entity = 'app/bank';

  static getPaymentBankConfig(): Promise<PaymentBankConfig[]> {
    return this.axios
      .get(`${this.entity}/payment-bank-config`)
      .then((res) => normalizePaymentBankConfigs(res.data));
  }

  static getMqrConsent(params: {
    bankAccount: string;
    bankCode: string;
  }): Promise<MqrConsentResponse> {
    return this.axios
      .get(`${this.entity}/mqr-consent`, {
        params: {
          BankAccount: params.bankAccount,
          BankCode: params.bankCode,
        },
      })
      .then((res) => normalizeMqrConsentResponse(res.data));
  }

}
